import React, { useEffect, useState } from "react";
import {
    Card, CardBody, Row, Col, Table, Badge, Input
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { toast } from "react-toastify";

const LowStockList = () => {

    const dispatch = useDispatch();
    const user = useSelector(s => s.customer.customer);

    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [limit] = useState(20);
    const [search, setSearch] = useState("");

    /* ================= LOAD LOW STOCK ================= */
    const load = async () => {
        dispatch(loadingTrue());
        try {
            const res = await Handler({
                method: "get",
                url: `/products/low_stock_alert.php?page=${page}&limit=${limit}&outlet_id=${user?.outlet_id}&q=${search}`
            });

            if (res?.success) {
                setRows(res.data.items || []);
                setTotal(res.data.total_low_stock || 0);
            } else {
                toast.error(res?.message || "Failed to load");
            }
        } catch {
            toast.error("Network error");
        }
        dispatch(loadingFalse());
    };

    useEffect(() => { load(); }, [page, search]);

    /* ================= UI ================= */
    return (
        <>
            <Row className="mb-3">
                <Col md={6}>
                    <h5 className="fw-bold">Low Stock Alert</h5>
                    <small className="text-muted">
                        Total Low Stock Items : {total}
                    </small>
                </Col>

                <Col md={6} className="text-end">
                    <Input
                        placeholder="Search product / variant / barcode"
                        value={search}
                        onChange={e => {
                            setSearch(e.target.value);
                            setPage(1);
                        }}
                        style={{ maxWidth: 280, display: "inline-block" }}
                    />
                </Col>
            </Row>

            <Card>
                <CardBody>

                    {/* 🔥 SAME TABLE STYLE AS PRODUCT LIST */}
                    <Table responsive className="modern-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Product</th>
                                <th>Meta</th>
                                <th className="text-end">Current Quantity</th>
                                <th className="text-end">Low Limit</th>
                                <th className="text-end">Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {rows.length === 0 && (
                                <tr>
                                    <td colSpan="6" className="text-center text-muted">
                                        No low stock items
                                    </td>
                                </tr>
                            )}

                            {rows.map((r, i) => (
                                <tr key={i}>
                                    <td>{(page - 1) * limit + i + 1}</td>

                                    <td>
                                        <b>{r.product_name}</b>
                                        {r.variant_name && (
                                            <div className="small text-muted">
                                                ↳ {r.variant_name}
                                            </div>
                                        )}
                                    </td>

                                    <td className="small text-muted">
                                        {r.barcode && <div>Barcode: {r.barcode}</div>}
                                        <div>Outlet: {r.outlet_id}</div>
                                    </td>

                                    <td className="text-end">
                                        <Badge color="danger">{r.quantity}</Badge>
                                    </td>

                                    <td className="text-end">
                                        {r.low_stock_limit}
                                    </td>

                                    <td className="text-end">
                                        <Badge color="warning">LOW STOCK</Badge>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <Pagination
                        page={page}
                        total={total}
                        limit={limit}
                        onPrev={() => setPage(p => Math.max(1, p - 1))}
                        onNext={() => setPage(p => p + 1)}
                    />

                </CardBody>
            </Card>
        </>
    );
};

export default LowStockList;
